import ImageAsset from "./Assets";
import {
  getCurrentDate,
  guidGenerator,
} from "../features/utils/commonFunctions";

export default class GalleryAsset {
  captionTextArray: string[];
  created: string;
  defaultPreviewAsset: string;
  fullSizedImages: ImageAsset[];
  lowQualityImages: ImageAsset[];
  thumbnailImages: ImageAsset[];
  updated: string;
  userChosenPreview: string;
  id: string;

  constructor(
    captionTextArray: string[] = [],
    created = getCurrentDate(),
    defaultPreviewAsset = "",
    fullSizedImages: ImageAsset[] = [],
    lowQualityImages: ImageAsset[] = [],
    thumbnailImages: ImageAsset[] = [],
    updated = getCurrentDate(),
    userChosenPreview = "",
    id = guidGenerator()
  ) {
    this.captionTextArray = captionTextArray;
    this.created = created;
    this.defaultPreviewAsset = defaultPreviewAsset;
    this.fullSizedImages = fullSizedImages;
    this.lowQualityImages = lowQualityImages;
    this.thumbnailImages = thumbnailImages;
    this.updated = updated;
    this.userChosenPreview = userChosenPreview;
    this.id = id;
  }

  static default(): GalleryAsset {
    return new GalleryAsset(
      [],
      getCurrentDate(),
      "",
      [],
      [],
      [],
      getCurrentDate(),
      "",
      guidGenerator()
    );
  }
}
